// extracted by mini-css-extract-plugin
export default {"form":"SupplierRegister_form__4WtJA","input":"SupplierRegister_input__PQJrH","div":"SupplierRegister_div__O0rKK","h2":"SupplierRegister_h2__jGSWG","p":"SupplierRegister_p__vKEJo"};